<template>
    <section>
        <slot :treeData="treeData"></slot>
    </section>
</template>

<script>
/**
 * API
 * - getPayApvlTreeList     tree列表
 */
import { getPayApvlTreeList } from '@/api/wage/paymentApproval'

export default {

    name: 'payApvlTree',

    data() {
        return {
            treeData: {
                list: [],
                defaultProps:  Object.freeze({
                    children: 'children',
                    label: 'orgName',
                }),
            }
        }
    },

    mounted() {
        this.getPayApvlTreeList()
    },

    methods: {
        /**
         * @description: tree列表
         */
        getPayApvlTreeList() {
            getPayApvlTreeList({ type: 3 }).then((res) => {
                if (!res.data.data.cusList || res.data.data.cusList.lenght === 0) return
                this.treeData.list = Object.freeze(res.data.data.cusList)
                // 默认点击第一个
                this.$nextTick().then(() =>{
                    const firstNode = document.querySelector('#lTree .el-tree-node')
                    firstNode.click()
                })
            })
        }
    }

}

</script>
